import Component from "../core/Component";
const ACTIVE = "is-active";

export default class NavLang extends Component {
   constructor(element) {
      super(element);
      this.openTimer = null;
      this.openTimerDuration = 20;
      this.closeTimer = null;
      this.closeTimerDuration = 200;
   }

   prepare() {
   
      this.element.addEventListener("click", ::this.handleClick);
      this.element.addEventListener("mouseenter", ::this.handleMouseEnter);
      this.element.addEventListener("mouseleave", ::this.handleMouseLeave);
   }

   handleClick() {
      if (window.innerWidth >= 1200) return;
      this.element.classList.toggle(ACTIVE);
   }

   handleMouseEnter = () => {
      if (window.innerWidth < 1199) return;
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.openTimer = setTimeout(() => {
         this.element.classList.add(ACTIVE);
      }, this.openTimerDuration);
   };

   handleMouseLeave = () => {
      if (window.innerWidth < 1199) return;
      this.closeTimer = setTimeout(() => {
         this.element.classList.remove(ACTIVE);
      }, this.closeTimerDuration);
   };
}
